module.exports = __webpack_public_path__ + "static/media/top_shape_3.5f069d69.svg";